<template>
    <div class="basic-info">
        <div class="info-header">
            <span class="info-header-txt">基础信息</span>
        </div>
        <el-form label-width="130px" class="basic-wrapper">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="任务单号：">
                        <span>{{ basicInfo.taskNo }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="订单类型：">
                        <span>{{ basicInfo.orderTypeName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="商超标识：">
                        <span>{{ scPosFlagName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="最终收货人姓名：">
                        <span>{{ basicInfo.finalName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="客户订单号：">
                        <span>{{ basicInfo.customerOrderNo }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="配送方式：">
                        <span>{{ basicInfo.deliveryTypeName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="是否要求拨号：">
                        <span>{{ requireDialFlagName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="最终收货人号码：">
                        <span>{{ basicInfo.finalMobile }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="时效考核时间：">
                        <span>{{ basicInfo.examineTime }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="业务模式：">
                        <span>{{ basicInfo.businessMode }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="要求前置预约：">
                        <span>{{ arriveAppointmentRequireName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="分配直通宝账号：">
                        <span>{{ basicInfo.driverPhone }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
   </div>
</template>

<script>
export default {
    name: 'BasicInformation',
    props: {
        basicInfo: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {};
    },
    computed: {
        arriveAppointmentRequireName() {
            return +this.basicInfo.arriveAppointmentRequireFlag === 3 ? '是' : '否';
        },
        requireDialFlagName() {
            return +this.basicInfo.requireDialFlag === 1 ? '是' : '否';
        },
        scPosFlagName() {
            return +this.basicInfo.scPosFlag === 1 ? '是' : '否';
        }
    }
};
</script>

<style lang="less" scoped>
@import '../appointmentDetail.less';
.basic-info {
    background-color: #fff;
    margin-bottom: 10px;
}
.basic-wrapper {
    .el-form-item {
        margin-bottom: 0px;
        span {
            font-size: 13px;
            font-weight: bold;
        }
    }
    /deep/ .el-form-item__label {
        font-size: 13px ;
    }
    /deep/ .el-form-item__content {
        white-space: nowrap; /*文字不换行，为了让文字溢出*/
    }
}
</style>
